import React, { createContext, useContext, useState, ReactNode } from 'react';
import type { StreamMessage } from 'stream-chat-react';
import type { StreamChatType } from '../types';

interface QuotedMessageContextType {
  quotedMessage: StreamMessage<StreamChatType> | null;
  setQuotedMessage: (message: StreamMessage<StreamChatType> | null) => void;
  clearQuotedMessage: () => void;
}

const QuotedMessageContext = createContext<QuotedMessageContextType | undefined>(undefined);

export const QuotedMessageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [quotedMessage, setQuotedMessage] = useState<StreamMessage<StreamChatType> | null>(null);

  const clearQuotedMessage = () => {
    setQuotedMessage(null);
  };

  return (
    <QuotedMessageContext.Provider value={{ quotedMessage, setQuotedMessage, clearQuotedMessage }}>
      {children}
    </QuotedMessageContext.Provider>
  );
};

export const useQuotedMessage = () => {
  const context = useContext(QuotedMessageContext);
  if (context === undefined) {
    throw new Error('useQuotedMessage must be used within a QuotedMessageProvider');
  }
  return context;
};

